<script>
  import { onMount } from 'svelte';
  import { currentUser } from './utils';
  import Dashboard from './components/Dashboard.svelte';
  export let user = null;
  export let currentClient = 'tony_kealys';
  let mounted = false;

  onMount(() => {
    if (user) {
      $currentUser = user;
    }
    mounted = true;
  });
</script>

{#if mounted}
  <main id="print-area">
    <h1>Reports</h1>
    <Dashboard />
  </main>
{/if}

<style>:global(*){box-sizing:border-box;margin:0}:global(html,body){font-family:Overpass,sans-serif;height:100%;width:100%}h1{font-family:Chivo,serif}main{margin:0 auto;position:relative;width:100%}</style>
